import { render, staticRenderFns } from "./shippingTime.vue?vue&type=template&id=576b4612&scoped=true&"
import script from "./shippingTime.vue?vue&type=script&lang=js&"
export * from "./shippingTime.vue?vue&type=script&lang=js&"
import style0 from "./shippingTime.vue?vue&type=style&index=0&id=576b4612&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576b4612",
  null
  
)

export default component.exports